/**
 * Tabbed Highlighted Content Block Interaction
 *
 * Handles switching tabs for the Tabbed Highlighted Content block.
 *
 * @param {boolean} [enableDebug=false] - Enable debug logging
 */
export default function(enableDebug = false) {
	const instances = document.querySelectorAll('.tabbed-highlighted-content');

	if (enableDebug) console.log(`[TabbedContent] Found ${instances.length} instance(s)`);

	if (instances.length === 0) return;

	instances.forEach((instance, index) => {
		if (enableDebug) console.log(`[TabbedContent] Initializing instance ${index + 1}`);

		const tabButtons = instance.querySelectorAll('.tabbed-highlighted-content__tab-button');
		const tabPanels = instance.querySelectorAll('.tabbed-highlighted-content__tab-panel');
		const highlights = instance.querySelectorAll('.tabbed-highlighted-content__highlight');
		const tabNav = instance.querySelector('.tabbed-highlighted-content__tabs-nav');

		// Tab click handler
		tabButtons.forEach(button => {
			button.addEventListener('click', () => {
				const tabId = button.dataset.tabId;
				if (enableDebug) console.log(`[TabbedContent] Tab clicked: ${tabId}`);
				activateTab(tabId);
			});
		});

		function activateTab(tabId) {
			if (enableDebug) console.log(`[TabbedContent] Activating tab ID: ${tabId}`);

			tabButtons.forEach(btn => {
				const isActive = btn.dataset.tabId === tabId;
				btn.classList.toggle('--active', isActive);
				btn.setAttribute('aria-selected', isActive);
			});

			tabPanels.forEach(panel => {
				const isActive = panel.dataset.tabId === tabId;
				panel.classList.toggle('--active', isActive);
				panel.setAttribute('aria-hidden', !isActive);
			});

			highlights.forEach(highlight => {
				const isActive = highlight.dataset.tabId === tabId;
				highlight.style.display = isActive ? 'block' : 'none';
			});
		}

		// Initial state update
		const activeBtn = instance.querySelector('.tabbed-highlighted-content__tab-button.--active');
		if (activeBtn) {
			if (enableDebug) console.log(`[TabbedContent] Initial active tab: ${activeBtn.dataset.tabId}`);
			activateTab(activeBtn.dataset.tabId);
		}

		// Enable drag-to-scroll if < 650px
		if (window.innerWidth < 650 && tabNav) {
			tabNav.classList.add('--grabbable');

			let isDown = false;
			let startX;
			let scrollLeft;

			tabNav.addEventListener('mousedown', e => {
				isDown = true;
				tabNav.classList.add('--dragging');
				startX = e.pageX - tabNav.offsetLeft;
				scrollLeft = tabNav.scrollLeft;
			});

			tabNav.addEventListener('mouseleave', () => {
				isDown = false;
				tabNav.classList.remove('--dragging');
			});

			tabNav.addEventListener('mouseup', () => {
				isDown = false;
				tabNav.classList.remove('--dragging');
			});

			tabNav.addEventListener('mousemove', e => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - tabNav.offsetLeft;
				const walk = (x - startX) * 1.5;
				tabNav.scrollLeft = scrollLeft - walk;
			});
		}
	});
}
